import React from 'react';
import { useTranslation } from 'react-i18next';

import DidNotParticipate from '../../resources/img/didNotParticipate.svg';
import Failed from '../../resources/img/failed.svg';
import Participated from '../../resources/img/participated.svg';
import Passed from '../../resources/img/passed.svg';
import { SessionAttendeeStatus } from '../utils/sessionAttendees';

const presentation: Record<
  SessionAttendeeStatus,
  { icons: string[]; className?: string }
> = {
  passed: { icons: [Participated, Passed] },
  failed: { icons: [Participated, Failed] },
  present: { icons: [Participated] },
  partlyPresent: { icons: [Participated], className: 'text-orange-600' },
  notPresent: { icons: [DidNotParticipate], className: 'text-warningRed' },
  notRecorded: { icons: [], className: 'text-blueGrayDark' },
};

const OpenClassAttendeeStatusBox: React.FC<{
  status: SessionAttendeeStatus;
}> = ({ status }) => {
  const { t } = useTranslation();
  const { icons, className } = presentation[status];

  return (
    <div className={`flex gap-2 ${className ?? ''}`}>
      {icons.map((icon) => (
        <img alt="" className="w-4" key={icon} src={icon} />
      ))}
      {t(`components.OpenClassAttendeeStatusBox.${status}`)}
    </div>
  );
};

export default OpenClassAttendeeStatusBox;
